import {Button, Card, DatePicker, Form, Input, Select, Spin} from 'antd';
import React from "react";

const { TextArea } = Input;
class Create extends React.Component {
  state = {
    remarks: '',
  };

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }

    this.props && this.props.fetchActivitySno();

  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {loading, title, resource, form, activities} = this.props;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <Form.Item key={'activities'}
                       label={'Select Activities'}>
              {getFieldDecorator('activities', {
                rules: [{
                  required: true,
                  message: `Activities is required!`
                }],
              })(<Select
                mode="multiple"
                allowClear
                showSearch
                showArrow={true}
                placeholder={`Please Select Activities`}
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
              >
                {activities && activities.map(item => <Select.Option key={item.activitySerialNo}>{item.activitySerialNo}</Select.Option>)}
              </Select>)}
            </Form.Item>

            <Form.Item key={'closureDate'} label={'Closure Date'}>
                  { getFieldDecorator('closureDate', {
                    rules: [{
                      required: true,
                      message: `Closure Date is required!`
                    }],
                  })(<DatePicker />)}
            </Form.Item>


            <Form.Item key={'remarks'} label= {'Remarks'}>
              { getFieldDecorator('remarks', {})(<TextArea rows={4} />)}
            </Form.Item>

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>Close</Button>
            </Form.Item>

          </Form>
        </Card>
      </Spin>
    );
  }
}
const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
  },
})(Create);

export default CreateForm;


